import React, { FC } from 'react';

import { lowEmphasisText } from './styles';

const NoResultsAvailable: FC = () => (
  // https://hello.atlassian.net/browse/PSREAU-1462 for today, show a tooltip about
  // why we don't have any data
  <p css={[lowEmphasisText]}>
    Latest results aren&apos;t available yet. <br />
    Please check back later.
  </p>
);

export default NoResultsAvailable;
